export enum EAutomationStatus {
    ACTIVE = 'active',
    DISABLED = 'disabled',
    NOT_SUFFICIENT_FUND = 'not_sufficient_funds',
}